export { default } from '@material-ui/core/TableHead';
